export default {
  edit (aModel) {
    this.editRelation('addresses', aModel)
  },

  delete (aModel) {
    this.deleteRelation('addresses', aModel)
  }
}



// WEBPACK FOOTER //
// ./src/functions/address.js